import moment from "moment"
import Form from "vform"

const NUM_OF_AP_COURSES_FILES = 4

export function getFormInformation(record) {
	return new Form({
		// Basics
		Id: record['Id'],
		email: record["Email"] || "",
		firstName: record["First_Name__c"] || "",
		lastName: record["Last_Name__c"] || "",
		dateOfBirth: record["Birthdate"]
        			? moment(record["Birthdate"]).format("MM/DD/YYYY")
        			: "",
		gender: record["Gender__c"] || "",
		program: record["Program__c"] || "",

		fieldOfInterest: record["Field_of_Interest__c"] || "",
		contactName: record["Name"] || "",
		addressState: record["MailingState"] || "",
		addressZip: record["PostalCode"] || "",
		// Applicant Tab
		maritalStatus: record["Marital_Status__c"] || "",
		currentlyEmployed: record["Currently_Employed__c"] || "",
		employer: record["Employer__c"] || "",
		jobTitle: record["Job_Title__c"] || "",
		employmentDate: record["Employment_Date__c"]
			? moment(record["Employment_Date__c"]).format("MM/DD/YYYY")
			: "",
		employmentType: record["Employment_Type__c"] || "",
		// Family & Emergency Tab
		fatherFirstName: record["Father_s_First_Name__c"] || "",
		fatherLastName: record["Father_s_Last_Name__c"] || "",
		fatherOccupation: record["Father_s_Occupation__c"] || "",
		fatherDeceased: record["Father_Deceased__c"],
		motherFirstName: record["Mother_s_First_Name__c"] || "",
		motherLastName: record["Mother_s_Last_Name__c"] || "",
		motherMaidenName: record["Mother_s_Maiden_Name__c"] || "",
		motherOccupation: record["Mother_s_Occupation__c"] || "",
		motherDeceased: record["Mother_Deceased__c"],
		SpouseFirstName: record["Spouse_First_Name__c"]|| "",
		SpouseMaidenName: record["Spouse_Maiden_Name__c"]|| "",
		SpouseLastName: record["Spouse_Last_Name__c"]|| "",
		SpouseOccupation: record["Spouse_Occupation__c"]|| "",
		SpouseEmail: record["Spouse_Email__c"]|| "",
		SpouseCellNumber: record["Spouse_s_Mobile__c"]|| "",
		emergencyContact: record["Emergency_Contact_Details_JSON__c"]
			? JSON.parse(record["Emergency_Contact_Details_JSON__c"])
			: {name: "",phone: "" , email: "", relationship: ""} ,

		// Transfer Credit Tab
		//OTD
		OTDCourse1 : record["Course_1_in_humanities_social_science__c"]
			? JSON.parse(record["Course_1_in_humanities_social_science__c"])
			: {status: "",college : "",  completion_date: ""},//
		OTDCourse2 :record["Course_2_in_humanities_social_science__c"]
			? JSON.parse(record["Course_2_in_humanities_social_science__c"])
			: {status: "",college : "",  completion_date: ""},//
		OTDCourse3 :record["Human_Development_or_Lifespan__c"]
			? JSON.parse(record["Human_Development_or_Lifespan__c"])
			: {status: "",college : "",  completion_date: ""},//
		OTDCourse4 :record["Statistics_OT__c"]
			? JSON.parse(record["Statistics_OT__c"])
			: {status: "",college : "",  completion_date: ""},//
		OTDCourse5 :record["Human_Anatomy_w_lab__c"]
			? JSON.parse(record["Human_Anatomy_w_lab__c"])
			: {status: "",college : "",  completion_date: ""},//
		OTDCourse6 :record["Physiology_w_lab__c"]
			? JSON.parse(record["Physiology_w_lab__c"])
			: {status: "",college : "",  completion_date: ""},//
		OTDCourse7 :record["Abnormal_or_Behavioral_Psychology__c"]
			? JSON.parse(record["Abnormal_or_Behavioral_Psychology__c"])
			: {status: "",college : "",  completion_date: ""},//
			 	OTDCourse8 :record["English_Composition__c"]
			? JSON.parse(record["English_Composition__c"])
			: {status: "",college : "",  completion_date: ""},//
		completedObservation : record["Observation_Hours__c"]
			? JSON.parse(record["Observation_Hours__c"])
			: {boolean: "", when: ""},

		//MSLP
		MSLPCourse1 : record["Anatomy_and_Physiology__c"]
			? JSON.parse(record["Anatomy_and_Physiology__c"])
			: {status: "",college : "",  completion_date: ""},

			MSLPCourse2 : record["Audiology__c"]
			? JSON.parse(record["Audiology__c"])
			: {status: "",college : "",  completion_date: ""},

			MSLPCourse3 : record["Introduction_to_Speech_Science__c"]
			? JSON.parse(record["Introduction_to_Speech_Science__c"])
			: {status: "",college : "",  completion_date: ""},
			MSLPCourse4 : record["Phonetics__c"]
			? JSON.parse(record["Phonetics__c"])
			: {status: "",college : "",  completion_date: ""},
			MSLPCourse5 : record["Survey_of_Communication_Disorders__c"]
			? JSON.parse(record["Survey_of_Communication_Disorders__c"])
			: {status: "",college : "",  completion_date: ""},
			MSLPCourse6 : record["Biology__c"]
			? JSON.parse(record["Biology__c"])
			: {status: "",college : "",  completion_date: ""},
			MSLPCourse7 : record["Chemistry_Physics__c"]
			? JSON.parse(record["Chemistry_Physics__c"])
			: {status: "",college : "",  completion_date: ""},
			MSLPCourse8 : record["Social_Behavioral_Science__c"]
			? JSON.parse(record["Social_Behavioral_Science__c"])
			: {status: "",college : "",  completion_date: ""},
			MSLPCourse9 : record["Statistics_SLP__c"]
			? JSON.parse(record["Statistics_SLP__c"])
			: {status: "",college : "",  completion_date: ""},
//nutrition

		NutritionCourse1 : record["Anatomy_and_Physiology_I_w_lab__c"]
			? JSON.parse(record["Anatomy_and_Physiology_I_w_lab__c"])
			: {status: "",college : "",  completion_date: ""},

		NutritionCourse2 : record["Anatomy_and_Physiology_II_w_lab__c"]
			? JSON.parse(record["Anatomy_and_Physiology_II_w_lab__c"])
			: {status: "",college : "",  completion_date: ""},

		NutritionCourse3 : record["Biochemistry_w_lab__c"]
			? JSON.parse(record["Biochemistry_w_lab__c"])
			: {status: "",college : "",  completion_date: ""},
		NutritionCourse4 : record["Chemistry_I_w_lab__c"]
			? JSON.parse(record["Chemistry_I_w_lab__c"])
			: {status: "",college : "",  completion_date: ""},
		NutritionCourse5 : record["Chemistry_II_w_lab__c"]
			? JSON.parse(record["Chemistry_II_w_lab__c"])
			: {status: "",college : "",  completion_date: ""},
		NutritionCourse6 : record["Microbiology_w_lab__c"]
			? JSON.parse(record["Microbiology_w_lab__c"])
			: {status: "",college : "",  completion_date: ""},

			// Statistics Fields
		Math_Prerequisite :  record["Math_Prerequisite__c"]
			? JSON.parse(record["Math_Prerequisite__c"])
			: {tookCourse: "",howTaken: "" } ,

		Math_Info :  record["Math_Info__c"]
			? JSON.parse(record["Math_Info__c"])
			: {typeClass: "", college: "", collegeOther: "", examTaken: "", examTakenOther:"", completion_date: ""} ,

		statisticsFile: {
			body: null,
			name: null
		},
		mathFile: {
			body: null,
			name: null
		},
		// Psychology Fields
		Intro_Psychology_Prerequisite :  record["Intro_Psychology_Prerequisite__c"]
		? JSON.parse(record["Intro_Psychology_Prerequisite__c"])
		: {tookCourse: "",howTaken: "" } ,

		Intro_Psychology_Info :  record["Intro_Psychology_Info__c"]
		? JSON.parse(record["Intro_Psychology_Info__c"])
		: {typeClass: "", college: "", collegeOther: "", examTaken: "", examTakenOther:"", completion_date: ""} ,
		// Biology Fields
		Intro_Biology_Prerequisite :  record["Science_Prerequisite__c"]
		? JSON.parse(record["Science_Prerequisite__c"])
		: {tookCourse: "",howTaken: "" } ,

		Intro_Biology_Info :  record["Science_Info__c"]
		? JSON.parse(record["Science_Info__c"])
		: {typeClass: "", college: "", collegeOther: "", examTaken: "", examTakenOther:"", completion_date: ""} ,
		// Business Fields
		Intro_English_Prerequisite :  record["English_Prerequisite__c"]
		? JSON.parse(record["English_Prerequisite__c"])
		: {tookCourse: "",howTaken: "" } ,
		Intro_English_Info :  record["English_Info__c"]
			? JSON.parse(record["English_Info__c"])
			: {typeClass: "", college: "", collegeOther: "", examTaken: "", examTakenOther:"", completion_date: ""} ,

		Business_Law_Info :  record["Business_Law_Info__c"]
		? JSON.parse(record["Business_Law_Info__c"])
		: {typeClass: "", college: "", collegeOther: "", examTaken: "", examTakenOther:"", completion_date: ""} ,
		Business_Law_Prerequisite :  record["Business_Law_Prerequisite__c"]
			? JSON.parse(record["Business_Law_Prerequisite__c"])
			: {tookCourse: "",howTaken: "" } ,



		// Programming Fields
		Programming_Prerequisite :  record["Programming_Prerequisite__c"]
		? JSON.parse(record["Programming_Prerequisite__c"])
		: {tookCourse: "",howTaken: "" } ,

		Intro_Programming_Info :  record["Programming_Info__c"]
		? JSON.parse(record["Programming_Info__c"])
		: {typeClass: "", college: "", collegeOther: "", examTaken: "", examTakenOther:"", completion_date: ""} ,

		introductionToPsychologyFile: {
			body: null,
			name: null
		},
		collegeAttending :record["College_Attending__c"]  ,
		applyingForGrants : record["Applying_for_FA__c"],

		govIDFileStatus :record[' Gov_ID_File_Status__c'] ,
		govIDFile: {
			body: null,
			name: null
		},
		introductionToProgrammingFile: {
			body: null,
			name: null
		},
		introductionToEnglishFile: {
			body: null,
			name: null
		},
		introductionToBiologyFile: {
			body: null,
			name: null
		},

		// Seminary Fields
		seminary: record["Seminary_r__c"] || "",
		seminaryName: record["Seminary_Name_r__c"] || "",
		seminaryCityStateCountry: record["Seminary_City_State_Country__c"] || "",
		seminaryCeeb: record["CEEB_Seminary__c"] || "",
		attendingSeminary: record["Planning_to_attend_SS_seminary__c"] || "",
		priorToSeminary: record["Prior_to_attend_SS_seminary__c"] || "",
		seminaryNameOther: record["Other_Seminary_Name__c"] || "",
		seminaryFile: {
			body: null,
			name: null
		},
		//this is diplaying what's in the box
		israelOption: record["Did_you_attend_an_Israel_Option_Program__c"] || "",
		israelOptionName : record["Which_Israel_Option_program_were_you_in__c"] || "",
		israelOptionCollege : record["Which_college_were_you_enrolled_for_IOP__c"] || "",
		// College Level or AP Courses Fields
		haveYouPassedCollegeLevelOrAPCourses: record["College_Level_or_AP_Courses__c"] || "",
		passedCollegeLevelOrAPCourses: record["Passed_College_Level_or_AP_Courses_JSON__c"]
			? JSON.parse(record["Passed_College_Level_or_AP_Courses_JSON__c"])
			: [{college: "",name: "" }],
		passedCollegeLevelOrAPCoursesFiles: generateApCoursesArray(), // #tkt-6521
		// Attachments Tab
		firstReferenceNameAndNumber: record["X1st_Reference_Name_and_Number_JSON__c"]
			? JSON.parse(record["X1st_Reference_Name_and_Number_JSON__c"])
			: {name: "", phone: "", email:"", relationship:""},
		secondReferenceNameAndNumber: record["X2nd_Reference_Name_and_Number_JSON__c"]
			? JSON.parse(record["X2nd_Reference_Name_and_Number_JSON__c"])
			: {name: "", phone: "", email:"", relationship:""},
		firstReferenceStatus: record["X1st_Reference_Status__c"],
		secondReferenceStatus: record["X2nd_Reference_Status__c"],
	firstRecommender: record["X1st_letter_of_recommendation_name__c"]
	? JSON.parse(record["X1st_letter_of_recommendation_name__c"])
	: {name: "", phone: "",email: "",   relationship:""},

	secondRecommender: record["X2nd_letter_of_recommendation_name__c"]
	? JSON.parse(record["X2nd_letter_of_recommendation_name__c"])
	: {name: "",  phone: "", email: "", relationship:""},
		thirdRecommender: record["X3rd_letter_of_recommendation_name__c"]
	? JSON.parse(record["X3rd_letter_of_recommendation_name__c"])
	: {name: "",  phone: "", email: "", relationship:""},


		pictureFile: {
			body: null,
			name: null
		},
		personalStatementFile: {
			body: null,
			name: null
		},
		ClinicalEssayFile: {
			body: null,
			name: null
		},diversityStatementFile: {
			body: null,
			name: null
		},
		essayFilePersonal:{
			body:null, name:null
		},
		essayFile: {
			body: null,
			name: null
		},
		resumeFile: {
			body: null,
			name: null
		},
		greFile: {
			body: null,
			name: null
		},
		observationFile: {
			body: null,
			name: null
		},
		ferpaFile  :{
			body: null,
			name: null
		},
		firstLetterOfRecommendationFile: {
			body: null,
			name: null
		},
		secondLetterOfRecommendationFile: {
			body: null,
			name: null
		},
		hsTranscriptFile: {
			body: null,
			name: null
		},
		undergraduateTranscriptFile: {
			body: null,
			name: null
		},
		graduateTranscriptFile: {
			body: null,
			name: null
		},
		firstLetterOfReferenceFile: {
			body: null,
			name: null
		},
		secondLetterOfReferenceFile: {
			body: null,
			name: null
		},
		// Prerequisite Course Transcript
		introToSpeechAndLanguagePathologyFile: {
			body: null,
			name: null
		},businessLawFile: {
			body: null,
			name: null
		},
		phoneticsFile: {
			body: null,
			name: null
		},
		audiologyFile: {
			body: null,
			name: null
		},
		speechScienceFile: {
			body: null,
			name: null
		},
		// Acknowledgement Tab
		certifyAllInformation: record["Certify_Application_Information__c"],
		fullName: record["Full_Name_Signature__c"] || "",
		fullNameSignature: {
			body: null
		},
		date: record["Date_Signature__c"] || "",
		dateSignature: {
			body: null
		},
		amount: [ 'Doctorate in Counseling Psychology'   ].indexOf(record["Field_of_Interest__c"]) != -1 ? 200: 150 ,
		lateFee:  (isTodayGreaterThanTargetDate('2026-07-20T04:01:00Z') ? 150 : 0 ),
		discountCode: "",
		Payment_Status : record["Payment_Status__c"],
		creditCardFullName: "",
		creditCardBillingZip: "",
		opaqueData: {
			value: null,
			descriptor: null
		},
		stepReached: record["Form_Step_Reached__c"] || "1",
		semesterApplied: record["Semester_Applied__c"] || "",
		requestId: ""
	})
}
 function isTodayGreaterThanTargetDate(targetDateET) {
	 const nowLocal = new Date();
	 const targetDate = new Date(targetDateET);
	 return nowLocal > targetDate;

}
export function getFormFiles(record) {
	return {
		// Family & Emergency Tab
		// Transfer Credit Tab
		// Statistics Fields
		statisticsFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		mathFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		// Psychology Fields
		introductionToPsychologyFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		introductionToBiologyFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},

		pictureFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		personalStatementFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		ClinicalEssayFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},diversityStatementFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		essayFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		resumeFile: {
			body: null,
			name: null,
			errors: null,
			validated: false
		},
		greFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		firstLetterOfRecommendationFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		secondLetterOfRecommendationFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		hsTranscriptFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		undergraduateTranscriptFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		graduateTranscriptFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		firstLetterOfReferenceFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		secondLetterOfReferenceFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		// Prerequisite Course Transcript
		introToSpeechAndLanguagePathologyFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		phoneticsFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		audiologyFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		speechScienceFile: {
			file: null,
			name: null,
			errors: null,
			validated: false
		},
		passedCollegeLevelOrAPCoursesFiles: generateApCoursesArray(),
	};
}

export function getBachelorFOIs() {
	return [
		"BA in Education and Special Education",
		"BA in Psychology",
		"BA in Psychology-Speech Track",
		"BA in Psychology - IMPACT Track",
		"BA in Psychology - Educ Track",
		"BA in Psychology - ABA Track",
		"BA in Psychology - Pre-Med Track",
		"BA in Psychology - Business Track",
		"BA in Psychology - Sonography Track",
		"BA in Psychology - Nursing Track",
		'BA in Psychology - Nutrition Track',
		'BA in Psychology - Occupational Therapy Track',
		"BA in Psychology-Social Work Track",
		"Bachelor of Science in Data Science",
		"Bachelor of Science in Legal Studies",
		"BA in Social Science",
		"BS in Social Work",
		"Bachelor of Professional Studies-MSW",
		"BS in Business Admin with Accounting Specialization",
		"BA in Business Administration","Bachelor of Science in Speech and Audiology",
		"BS in Accounting"
	]
}

export function getMasterFOIs() {
	return [
		"MBA",
		"Master in Cyber Security",
		"MS in Education and Special Education",
		"MS in Accounting",
		"MPS in Applied Behavior Analysis (ABA) – LBA & BCBA",
		"MA in Digital Marketing",
		"MS in Digital Marketing",
		"MSW in Social Work",
		"Occupational Therapy Doctorate (OTD)",
		"Doctorate in Counseling Psychology",
		"MS in Nutrition",
		"MSW in Social Work - Advanced Standing"
	]
}

function generateApCoursesArray() {
	let arr = []

	for (let index = 0; index < NUM_OF_AP_COURSES_FILES; index++) {
		arr.push({
			file: null,
			name: null,
			errors: null
		});
	}

	return arr
}



// WEBPACK FOOTER //
// ./resources/js/services/detailsService.js